import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchApi } from "Config/fetchApi";
import { getUserInfo } from "Config/getUserInfo";
import { handleError } from "Helper";

// Initial state
const initialState = {
  ipCamList: {
    dataIpCamList: [],
    isLoadingIpCamList: false,
    errorIpCamList: null,
  },
};

// Get user configuration
const user = getUserInfo() || {};
const organizationId =
  user?.userInfo?.jurisdiction_level_code === "N"
    ? ""
    : user?.userInfo?.organization_id || "";
// console.log( user?.userInfo, ' user?.userInfo')

// Thunk action for fetching IP Cam list
export const getIpCamList = createAsyncThunk(
  "ipCam/getIpCamList",
  async ({ page = 0, size = 99, keywords = "" } = {}, { rejectWithValue }) => {
    try {
      const api = fetchApi(); // Menggunakan fetchApi
      const url = `/streaming-device/get-list?keywords=${keywords}&organizationId=${organizationId}&page=${page}&size=${size}`;
      const result = await api.get(url);
      return result?.data?.data;
    } catch (error) {
      handleError(error);
      console.error(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Slice definition
const ipCamSlice = createSlice({
  name: "ipCam",
  initialState,
  reducers: {
    cleardataIpCamList: (state) => {
      state.ipCamList.dataIpCamList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIpCamList.pending, (state) => {
        state.ipCamList.isLoadingIpCamList = true;
        state.ipCamList.errorIpCamList = null;
      })
      .addCase(getIpCamList.fulfilled, (state, action) => {
        state.ipCamList.isLoadingIpCamList = false;
        state.ipCamList.dataIpCamList = action.payload || [];
        state.ipCamList.errorIpCamList = null;
      })
      .addCase(getIpCamList.rejected, (state, action) => {
        state.ipCamList.isLoadingIpCamList = false;
        state.ipCamList.errorIpCamList = action.payload;
      });
  },
});
export const { cleardataIpCamList } = ipCamSlice.actions;
export default ipCamSlice.reducer;
